module.exports = __webpack_public_path__ + "static/media/voice_over.9cf69f4c.svg";